/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { DownloadUrlRequestBuilderRequestsMetadata, type DownloadUrlRequestBuilder } from './downloadUrl/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/exports/{id}
 */
export interface ExportsItemRequestBuilder extends BaseRequestBuilder<ExportsItemRequestBuilder> {
    /**
     * The downloadUrl property
     */
    get downloadUrl(): DownloadUrlRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ExportsItemRequestBuilderUriTemplate = "{+baseurl}/api/exports/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ExportsItemRequestBuilderNavigationMetadata: Record<Exclude<keyof ExportsItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    downloadUrl: {
        requestsMetadata: DownloadUrlRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
